import {readCachedLocalStorage, STORAGE_CACHE_KEYS} from "../Session/cachedLocalStorage";
import {getTaggedLogger} from "../Session/taggedLogging";
import {last} from "lodash";
import {anyPopupIsOpen} from "../lib/popupStatus";

const STORAGE_KEY = STORAGE_CACHE_KEYS.TRIGGER_HISTORY;

const LOGGER = getTaggedLogger('PageTriggers');

const isDev = (process.env.NODE_ENV == 'development');

export function getTriggerImpediment({trigger, now, logger= LOGGER}) {
  let allHistory = readAllTriggerHistory() || {};
  let history = allHistory[trigger.id] || {};

  let { triggeredAtList=[], count=0 } = history;

  let triggeredAt = last(triggeredAtList);
  logger.info(`triggered at: ${triggeredAtList} last=${triggeredAt}`);

  if (!triggeredAt)
    return null;

  let { intervalSeconds = 3600, maxOccurrences = 10, resetSeconds = 4*3600 } = trigger;

  now ||= new Date().getTime();

  let diff = (now - triggeredAt) / 1000;
  // // FIXME DEV
  // if (isDev) intervalSeconds = 15;

  // logger.info(`diff ${diff} interval ${intervalSeconds}`)

  if (diff < intervalSeconds) {
    return {
      blocked: true,
      message: `trigger activated ${diff} seconds ago, minimum interval ${intervalSeconds}`
    };
  }

  if (maxOccurrences && (count >= maxOccurrences)) {
    return {
      blocked: true,
      message: `trigger has already fired ${count} times`
    };
  }

  if (trigger.flavour === 'show_klaviyo_form') {
    if (anyPopupIsOpen()) {
      return { blocked: true, message: "Another popup is already open" }
    }
  }

  return null;
}

export function recordTriggerEvent({trigger, allHistory, now, logger= LOGGER}) {
  now ||= new Date();

  allHistory = readAllTriggerHistory() || {};
  let history = allHistory[trigger.id] || {
    id: trigger.id,
    count: 0,
    triggeredAtList: []
  }

  history.triggeredAtList.push(now.getTime());

  allHistory[trigger.id] = history;
  writeAllTriggerHistory(allHistory);
}

function readAllTriggerHistory() {
  return readCachedLocalStorage(STORAGE_KEY, {defaultValue: {}})
}

function writeAllTriggerHistory(history) {
  return writeCachedLocalStorage(STORAGE_KEY, history || {}, {
    expiresIn: 4 * 3600
  })
}
